module.exports = __webpack_public_path__ + "static/media/modalBuddies@2x.672bbb22.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/modalBuddies@2x.png
// module id = 1891
// module chunks = 0